var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiWhite1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.535,
    height: 25.5,
    viewBox: "0 0 25.535 25.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-width: 0.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9701",
    "data-name": "Group 9701",
    transform: "translate(-107.75 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9661",
    "data-name": "Group 9661",
    transform: "translate(116.203 8.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9659",
    "data-name": "Group 9659",
    transform: "translate(1.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6999",
    "data-name": "Path 6999",
    className: "cls-1",
    d: "M136.344,26.469c-1.328,0-2.344-1.25-2.344-2.93,0-1.172.273-2.539,2.344-2.539s2.344,1.367,2.344,2.539C138.688,25.219,137.672,26.469,136.344,26.469Zm0-4.687c-1.172,0-1.562.43-1.562,1.758,0,1.055.547,2.148,1.563,2.148s1.563-1.094,1.563-2.148C137.906,22.211,137.516,21.781,136.344,21.781Z",
    transform: "translate(-134 -21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9660",
    "data-name": "Group 9660",
    transform: "translate(0 4.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7000",
    "data-name": "Path 7000",
    className: "cls-1",
    d: "M136.422,36.358h-6.25c-.625,0-1.172-.7-1.172-1.562v-.781a.41.41,0,0,1,.2-.352L131.93,32.1l.391.664-2.539,1.445V34.8c0,.469.273.781.391.781h6.25c.117,0,.391-.312.391-.781v-.547L134.273,32.8l.391-.664L137.4,33.7a.41.41,0,0,1,.2.352v.781A1.414,1.414,0,0,1,136.422,36.358Z",
    transform: "translate(-129 -32.1)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9662",
    "data-name": "Group 9662",
    transform: "translate(118.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7001",
    "data-name": "Path 7001",
    className: "cls-1",
    d: "M138.734,3.125h-2.344A.369.369,0,0,1,136,2.734V.391A.369.369,0,0,1,136.391,0h2.344a.369.369,0,0,1,.391.391V2.734A.369.369,0,0,1,138.734,3.125Zm-1.953-.781h1.563V.781h-1.562Z",
    transform: "translate(-136 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9663",
    "data-name": "Group 9663",
    transform: "translate(118.527 21.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7002",
    "data-name": "Path 7002",
    className: "cls-1",
    d: "M138.485,59.155H135.36a.41.41,0,0,1-.352-.2.355.355,0,0,1,0-.391l1.563-2.344a.4.4,0,0,1,.664,0L138.8,58.57a.355.355,0,0,1,0,.391A.309.309,0,0,1,138.485,59.155Zm-2.383-.781h1.68l-.82-1.25Z",
    transform: "translate(-134.95 -56.05)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9664",
    "data-name": "Group 9664",
    transform: "translate(108 10.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7003",
    "data-name": "Path 7003",
    className: "cls-1",
    d: "M109.563,31.125a1.562,1.562,0,1,1,1.562-1.562A1.567,1.567,0,0,1,109.563,31.125Zm0-2.344a.781.781,0,1,0,.781.781A.784.784,0,0,0,109.563,28.781Z",
    transform: "translate(-108 -28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9665",
    "data-name": "Group 9665",
    transform: "translate(129.875 10.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7004",
    "data-name": "Path 7004",
    className: "cls-1",
    d: "M166.734,31.125a.355.355,0,0,1-.273-.117l-2.344-2.344a.387.387,0,0,1,.547-.547l2.344,2.344a.378.378,0,0,1,0,.547A.355.355,0,0,1,166.734,31.125Z",
    transform: "translate(-164 -28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9666",
    "data-name": "Group 9666",
    transform: "translate(129.875 10.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7005",
    "data-name": "Path 7005",
    className: "cls-1",
    d: "M164.391,31.125a.355.355,0,0,1-.273-.117.378.378,0,0,1,0-.547l2.344-2.344a.387.387,0,0,1,.547.547l-2.344,2.344A.355.355,0,0,1,164.391,31.125Z",
    transform: "translate(-164 -28)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9667",
    "data-name": "Group 9667",
    transform: "translate(109.563 1.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7006",
    "data-name": "Path 7006",
    className: "cls-1",
    d: "M112.742,12.22l-.742-.2A11.334,11.334,0,0,1,120.125,3.9l.2.742A10.5,10.5,0,0,0,112.742,12.22Z",
    transform: "translate(-112 -3.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9668",
    "data-name": "Group 9668",
    transform: "translate(109.523 15.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7007",
    "data-name": "Path 7007",
    className: "cls-1",
    d: "M120.064,47.181A11.334,11.334,0,0,1,111.9,39.1l.742-.2a10.51,10.51,0,0,0,7.578,7.539Z",
    transform: "translate(-111.9 -38.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9669",
    "data-name": "Group 9669",
    transform: "translate(123.117 15.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7008",
    "data-name": "Path 7008",
    className: "cls-1",
    d: "M146.9,47.12l-.2-.742a10.561,10.561,0,0,0,7.578-7.578l.742.2A11.206,11.206,0,0,1,146.9,47.12Z",
    transform: "translate(-146.7 -38.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9670",
    "data-name": "Group 9670",
    transform: "translate(123.156 1.563)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7009",
    "data-name": "Path 7009",
    className: "cls-1",
    d: "M154.339,12.281A10.524,10.524,0,0,0,146.8,4.742L147,4a11.233,11.233,0,0,1,8.086,8.086Z",
    transform: "translate(-146.8 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9671",
    "data-name": "Group 9671",
    transform: "translate(114.25 12.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2737",
    "data-name": "Rectangle 2737",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9672",
    "data-name": "Group 9672",
    transform: "translate(112.688 12.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9673",
    "data-name": "Group 9673",
    transform: "translate(127.531 12.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2739",
    "data-name": "Rectangle 2739",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9674",
    "data-name": "Group 9674",
    transform: "translate(125.969 12.109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2740",
    "data-name": "Rectangle 2740",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9675",
    "data-name": "Group 9675",
    transform: "translate(120.109 17.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2741",
    "data-name": "Rectangle 2741",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9676",
    "data-name": "Group 9676",
    transform: "translate(120.109 19.531)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2742",
    "data-name": "Rectangle 2742",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9677",
    "data-name": "Group 9677",
    transform: "translate(120.109 4.687)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2743",
    "data-name": "Rectangle 2743",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9678",
    "data-name": "Group 9678",
    transform: "translate(120.109 6.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679",
    transform: "translate(125.969 17.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9680",
    "data-name": "Group 9680",
    transform: "translate(114.25 17.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9681",
    "data-name": "Group 9681",
    transform: "translate(125.969 6.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9682",
    "data-name": "Group 9682",
    transform: "translate(114.25 6.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    className: "cls-1",
    width: 0.781,
    height: 0.781
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiWhite1);
export default __webpack_public_path__ + "static/media/siWhite1.428656d072ffb2c09cb44f15b7a7536e.svg";
export { ForwardRef as ReactComponent };